/**
 * Settings buttons.
 */
export enum SettingsButtons {
    CLOSE = "close",
    SETTINGS = "settings",
    AUTOPLAY = "autospin",
    BET_OPTIONS = "bet",
    RIGHT_ARROW = "next",
    LEFT_ARROW = "previous",
    SOUND_OFF = "soundOff",
    SOUND_ON = "soundOn",
    SOUND = "sound",
    MUSIC = "music",
    CURSOR = "cursor",
    JACKPOT = "jackpot",
    TURBO = "turbo",
    HOME = "home",
    SPINS_COUNT = "spinsCount",
    LOSS_AMOUNT = "lossAmount",
    WIN_AMOUNT = "winAmount",
    CLEAR = "clear",
    PLAY = "play",
    HISTORY = "history",
    OPTIONS = "options",
    INFO = "info"
}
